import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LandingPageLanguageComponent from "./landingPageLanguageComponent";
import "./landingPage.scss";
import { LoadingComponent } from "../../components/layout/loading/LoadingComponent";
import { getProjects } from "../../utils/api/restClient";

function LandingPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [language, setLanguage] = useState("sv-SE");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsData = await getProjects();
        const activeProjects = projectsData
          .filter(project => project.isActive)
          .sort((a, b) => {
            const orderA = a.displayOrder ?? Number.MAX_VALUE;
            const orderB = b.displayOrder ?? Number.MAX_VALUE;
            return orderA - orderB;
          });

        setProjects(activeProjects);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const handleProjectClick = (slug) => {
    window.location.href = `/${slug}`;
  };

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
  };


  const getProjectName = (project) => {
    try {
      // check if project has translations
      if (project.translations && Array.isArray(project.translations) && project.translations.length > 0) {
        // try to find swedish translation first
        const svTranslation = project.translations.find(t => t.locale === "sv-SE");
        if (svTranslation && svTranslation.displayName) {
          return svTranslation.displayName;
        }
        
        // if swedish not exists, use selected language
        const currentTranslation = project.translations.find(t => t.locale === language);
        if (currentTranslation && currentTranslation.displayName) {
          return currentTranslation.displayName;
        }
      }
      
      // Fallback to project.name if missing transations
      return project.name || "???";
    } catch (error) {
      console.error("Error getting project name:", error);
      return project.name || "???";
    }
  };

  if (loading) return <LoadingComponent />;

  return (
    <div className="min-vh-100 d-flex flex-column">
      <div className="container px-4" style={{ maxWidth: '600px' }}>
        <div className="text-center mt-5 pt-5">
          <h1>Nobina-Biljetten</h1>
          <LandingPageLanguageComponent onLanguageChange={handleLanguageChange} />
        </div>
        
        <div >
          <h2 className="text-center ">
            {language === "sv-SE" && "Köp biljetter"}
            {language === "en-US" && "Buy tickets"}
            {language === "fi-FI" && "Osta liput"}
            {language === "nb-NO" && "Kjøp billetter"}
            {language === "da-DK" && "Køb billetter"}
          </h2>
          <div className="d-flex flex-column gap-3">
            {projects.length > 0 ? (
              projects.map((project) => (
                <button
                  key={project.id}
                  className="btn btn-success btn-lg w-100 py-3"
                  onClick={() => handleProjectClick(project.slug)}
                >
                  {getProjectName(project)}
                </button>
              ))
            ) : (
              <p className="text-center"></p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;